export const s3ImageLink = 'https://website-resource.ahaglobal.io/ads-platform/';

export const supportEmail = 'support@ahacreator.com';

export const supportWechatUrl = 'https://work.weixin.qq.com/kfid/kfc8d6e05d306d2903a';

export const supportWechatQrImageUrl = `${s3ImageLink}auth-wechat-support-20261023.png`;
export const supportWechatCloseIconUrl = `${s3ImageLink}auth-wechat-close-20261023.svg`;

export const ahaCreatorLink = 'https://www.ahacreator.com';
